<template>
  <div>
    <div class="text-xs-right">
      <div>
        <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
      </div>
      <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
      <v-btn :loading="exportloading" color="grey" outline @click="exportxlsx">
        <em class="fas fa-file-export" />
        &nbsp; Export&nbsp;
      </v-btn>
      <v-btn depressed color="primary" @click="addBranch">ADD</v-btn>
      <v-btn depressed color="primary" @click="DeleteAllProducts">Delete All</v-btn>
    </div>
    <v-pagination
      v-model="pageNumber"
      :total-visible="15"
      :length="pagelength"
      @input="changePage"
    ></v-pagination>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template #items="props">
        <tr>
          <td>
            {{ props.item.material_no }}
          </td>
          <td>
            {{ props.item.marketing_group }}
          </td>
          <td>
            {{ props.item.sub_marketing_group }}
          </td>
          <td>
            {{ props.item.product_name_th }}
          </td>
          <td>
            {{ props.item.product_name_en }}
          </td>
          <td>
            {{ props.item.product_size }}
          </td>
          <td>
            {{ props.item.score }}
          </td>
          <td class="text-xs-right">
            <v-btn icon @click="editProduct(props.item)"> <v-icon>edit</v-icon></v-btn>
            <v-btn icon @click="deleteProduct(props.item)"> <v-icon>delete</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div>
      <v-dialog v-model="showEdit" persistent width="550px">
        <v-card v-if="showEdit">
          <ProductEdit
            :edittype="edittype"
            :editdata="editdata"
            @onsave="onsave"
            @close="showEdit = false"
          ></ProductEdit>
        </v-card>
      </v-dialog>
    </div>
    <v-dialog v-model="showsearch" width="500px" persistent>
      <v-card>
        <div style="float: right">
          <v-btn icon @click="showsearch = false"><v-icon>close</v-icon></v-btn>
        </div>
        <div class="pa-2 pt-4 pb-3">
          <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
          <div>
            <v-layout class="pa-0 ma-0" wrap row>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('Material No') }}</label>
                <input v-model="filter.material_no" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm6 class="form-control pa-1">
                <label>{{ $t('Marketing Group') }}</label>
                <input v-model="filter.marketing_group" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Sub Marketing Group') }}</label>
                <input v-model="filter.sub_marketing_group" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Product Name TH') }}</label>
                <input v-model="filter.product_name_th" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Product Name EN') }}</label>
                <input v-model="filter.product_name_en" class="form-control" type="text" />
              </v-flex>
              <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('Product Size') }}</label>
                <input v-model="filter.product_size" class="form-control" type="text" />
              </v-flex>
            </v-layout>
          </div>
          <div class="text-xs-center">
            <v-btn outline color="grey" @click="clearsearch">Clear</v-btn>
            <v-btn color="primary" @click="onsearch">Search</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import { mapGetters } from 'vuex'
import ProductEdit from './ProductEdit.vue'
import VueQr from 'vue-qr'
import XLSX from 'xlsx'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint.js'

export default {
  components: {
    ProductEdit,
    VueQr,
    importxlsx,
    exportxlsx
  },
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      qrlink: '',
      qrdialog: false,
      importloading: false,
      qrdata: '',
      showEdit: false,
      editdata: '',
      edittype: '',

      pagination: { rowsPerPage: -1, sortBy: 'branch_id' },
      columnName: '',
      items: [],
      filter: {
        material_no: '',
        marketing_group: '',
        sub_marketing_group: '',
        product_name_en: '',
        product_name_th: '',
        product_size: ''
      },
      exportloading: false,
      showsearch: false,
      loading: false,
      headers: [
        { text: 'Material No.', value: 'material_no' },
        { text: 'Margeting Group', value: 'marketing_group' },
        { text: 'Sub Marketing Group', value: 'sub_marketing_group' },
        { text: 'Product Name TH', value: 'product_name_th' },
        { text: 'Product Name EN', value: 'product_name_en' },
        { text: 'Product Size', value: 'product_size' },
        { text: 'Score', value: 'score' },
        { text: '', value: '' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getProduct()
  },
  methods: {
    deleteProduct(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then(async (result) => {
          if (result.value) {
            this.loading = true
            var data = {
              id: item.id,
              pageid: this.selectedBot.pageid,
              page_id: this.selectedBot.pageid,
              campaign_id: this.$store.state.selectToaCampaign
                ? this.$store.state.selectToaCampaign.id
                : null
            }

            if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
              try {
                await toaMegapaintApi.deleteProduct(data)
                this.getProduct()
                this.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
                this.$emit('onsave')
              } catch (error) {
                console.error(error)
              } finally {
                this.loading = false
              }
            } else {
              api.deleteProductToaecoupon(data, (err, response) => {
                this.loading = false
                if (response.responsecode == 200) {
                  this.getProduct()
                  this.$swal.fire({
                    type: 'success',
                    text: 'สำเร็จ'
                  })
                }
              })
            }
          }
        })
    },
    clearsearch() {
      ;(this.filter = {
        material_no: '',
        marketing_group: '',
        sub_marketing_group: '',
        product_name_en: '',
        product_name_th: '',
        product_size: ''
      }),
        this.getProduct()
      this.showsearch = false
    },
    onsearch() {
      this.getProduct()
      this.showsearch = false
    },
    async exportxlsx() {
      var data = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        limit: this.total,
        offset: this.offset,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }

      this.exportloading = true

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          let response = await toaMegapaintApi.getProduct(data)
          var exporteddata = response.data.data

          var json = exporteddata.map((el) => {
            return {
              'Material no.': el.material_no,
              'Marketing Group': el.marketing_group,
              'Sub Marketing Group': el.sub_marketing_group,
              'Product Name EN': el.product_name_th,
              'Product Name TH': el.product_name_en,
              Size: el.product_size,
              Score: el.score
            }
          })

          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'exportedproduct' + '.xlsx')
        } catch (error) {
          console.error(error)
        } finally {
          this.exportloading = false
        }
      } else {
        api.getProductToaecoupon(data, (err, response) => {
          var exporteddata = response.data

          var json = exporteddata.map((el) => {
            return {
              'Material no.': el.material_no,
              'Marketing Group': el.marketing_group,
              'Sub Marketing Group': el.sub_marketing_group,
              'Product Name EN': el.product_name_th,
              'Product Name TH': el.product_name_en,
              Size: el.product_size,
              Score: el.score
            }
          })

          const dataWS = XLSX.utils.json_to_sheet(json)
          const wb = XLSX.utils.book_new()
          XLSX.utils.book_append_sheet(wb, dataWS)
          XLSX.writeFile(wb, 'exportedproduct' + '.xlsx')
          this.exportloading = false
        })
      }
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0],
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      api.importProductToaecoupon(data, async (err, response) => {
        this.importloading = false
        await this.$swal.fire({
          text: 'สำเร็จ',
          type: 'success'
        })
        this.getProduct()
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getProduct()
      }
    },
    editProduct(item) {
      this.editdata = item
      this.edittype = 'edit'
      this.showEdit = true
    },
    onsave() {
      this.showEdit = false
      this.getProduct()
    },
    gotolink(link) {
      this.$nextTick(() => {
        window.location.href = link
      })
      // location.assign(this.qrlink)
    },
    addBranch() {
      this.edittype = 'create'
      this.showEdit = true
    },
    async getProduct() {
      var data = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        material_no: this.filter.material_no,
        marketing_group: this.filter.marketing_group,
        sub_marketing_group: this.filter.sub_marketing_group,
        product_name_en: this.filter.product_name_en,
        product_name_th: this.filter.product_name_th,
        product_size: this.filter.product_size,
        limit: this.limit,
        offset: this.offset,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }

      for (const key in this.filter) {
        if (this.filter[key]) {
          Object.assign(data, { [key]: this.filter[key] })
        }
      }
      this.loading = true
      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          let response = await toaMegapaintApi.getProduct(data)
          response = response.data
          this.items = response.data
          this.total = response.total
        } catch (error) {
          console.error(error)
        } finally {
          this.loading = false
        }
      } else {
        api.getProductToaecoupon(data, (err, response) => {
          this.loading = false
          this.items = response.data
          this.total = response.total
        })
      }
    },
    DeleteAllProducts() {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete this?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            vm.$store.dispatch('loading')
            var data = {
              pageid: vm.selectedBot.pageid,
              campaign_id: this.$store.state.selectToaCampaign
                ? this.$store.state.selectToaCampaign.id
                : null
            }
            api.TOAECOUPONDeleteAllProducts(data, (err, response) => {
              vm.$store.dispatch('loading')
              vm.getProduct()
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/Product.vue